// extracted by mini-css-extract-plugin
export default {"input":"G_-z","button":"H_-z","selected":"I_-z","unavailable":"J_-z","oos":"K_-z","image":"L_-z","paperCutDisabledOverlay":"M_-z"};